import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as MapPin2FillIcon } from "../../assets/map-pin-2-fill.svg";

export const MapPin2Fill = (props) => {
  return <Icon as={MapPin2FillIcon} {...props} />;
};
